module.exports = __webpack_public_path__ + "static/img/icon55.8c7b79b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon55.png
// module id = 3Y+E
// module chunks = 0